import { createFileRoute } from "@tanstack/react-router";
import { ContactPage } from "@/components/contacts/ContactPage";
import { contactsSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/contacts")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => contactsSeo(loaderData?.href ?? "/contacts"),
  component: ContactPage,
});
